<template>
  <el-carousel
    class="relative w-full overflow-hidden"
    height="29.9vw"
    arrow="hover"
    indicator-position="bottom"
    :interval="5000"
    trigger="click"
  >
    <el-carousel-item v-for="(image, index) in images" :key="index" class="p-0">
      <!-- 添加外层容器确保尺寸 -->
      <div
        class="w-full h-full flex items-center justify-center overflow-hidden"
      >
        <img
          class="w-full h-full object-cover object-center"
          :src="image"
          :alt="`Banner ${index + 1}`"
        />

        <!-- banner1 -->
        <div
          v-if="index === 0"
          class="absolute"
          :style="{ left: '18.8vw', top: '20.5vw',display: 'flex' }"
        >
<!--          <el-button-->
<!--            class="flex mx-auto justify-center items-center custom-button"-->
<!--            @mouseenter="hoverButton = true"-->
<!--            @mouseleave="hoverButton = false"-->
<!--            @click="$router.push({ name: 'JoinUs' })"-->
<!--          >-->
<!--            免费试听-->
<!--          </el-button>-->
            <el-button
                    native-type="submit"
                    class="flex mx-auto justify-center items-center custom-button"
                    @mouseenter="hoverButton = true"
                    @mouseleave="hoverButton = false"
                    @click="triggerScroll"
            >
                申请加盟
            </el-button>
        </div>

        <!-- banner2 -->
        <div
          v-if="index === 1"
          class="absolute"
          :style="{ left: '18.8vw', top: '20.5vw' }"
        >
          <el-button
            native-type="submit"
            class="flex mx-auto justify-center items-center custom-button"
            @mouseenter="hoverButton = true"
            @mouseleave="hoverButton = false"
            @click="triggerScroll"
          >
<!--              @click="$router.push({ name: 'CourseSystem' })"-->
            申请加盟
          </el-button>
        </div>

      </div>
      <div></div>
      <div></div>
    </el-carousel-item>
  </el-carousel>
</template>


<script>
import {EventBus} from "@/utils/bus";
import {listBanner} from "@/api/banner";

export default {
  name: "home-module1",
  data() {
    return {
      images: [
          "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/banner/banner1.png",
          "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/banner/banner2.png",
          "https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/banner/banner3.png"
      ],
    };
  },
  methods: {
    async loadBannerImages() {
        const res = await listBanner();
        if (res.resultCode !== 0) {

            const context = require.context(
                "@/assets/images/Home/module1",
                false,
                /banner\d+\.(png|jpe?g|webp)$/i
            );

            // 按文件名数字排序后返回
            return context
                .keys()
                .sort((a, b) => {
                    const numA = parseInt(a.match(/\d+/)[0]);
                    const numB = parseInt(b.match(/\d+/)[0]);
                    return numA - numB;
                })
                .map(context);
        }else {
            this.images = res.data;
        }
    },
      triggerScroll(){
          EventBus.$emit('scroll-to-form','home6');
      }
  },
    mounted() {
      // this.loadBannerImages();
    }
};
</script>

<style scoped>
/* 底部指示器样式 */
:deep(.el-carousel__indicator) {
  padding: 0 0.36vw;
  margin: 2vw 0;
}

:deep(.el-carousel__button) {
  width: 3.5vw;
  height: 0.28vw;
  border-radius: 0.28vw;
  background: rgba(5, 53, 140, 0.4);
}

/* 调整切换箭头样式 */
:deep(.el-carousel__arrow) {
  width: auto;
  height: auto;
  bottom: 2vw;
  font-size: 5vw;
  color: rgba(255, 255, 255, 0.6);
  background: transparent !important;
  border-radius: 50%;
  box-shadow: none;
}

:deep(.el-carousel__arrow--left) {
  left: 10.417vw;
  transform: translateY(-50%);
}

:deep(.el-carousel__arrow--right) {
  right: 10.417vw;
  transform: translateY(-50%);
}

/* 自定义按钮样式 */
/* 自定义按钮样式 */
.custom-button {
  width: 6.87vw;
  height: 2.92vw;
  background: #f28334 !important;
  border: none;
  border-radius: 0.25vw;
  transition: all 0.3s;
}

.custom-button :deep(span) {
  color: white;
  font-size: 1.04vw;
  font-weight: bold;
  font-family: "HarmonyOS Sans SC";
}

.custom-button:hover {
  transform: scale(1.05);
  box-shadow: 0 0.2vw 0.6vw rgba(242, 131, 52, 0.5);
}
</style>
